import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getRepairRequestApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'REPAIR_REQUEST_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到報修單資料';
  }

  if (code === 'CRM_CUSTOMER_NOT_ACTIVE') {
    return data?.message || '客戶已停用，請改選啟用中的客戶';
  }

  if (code === 'REPAIR_REQUEST_NO_REQUIRED') {
    return data?.message || '請填寫報修單號';
  }

  if (code === 'REPAIR_REQUEST_NO_DUPLICATED') {
    return data?.message || '報修單號已存在，請改用其他單號';
  }

  if (code === 'REPAIR_REQUEST_DATE_REQUIRED') {
    return data?.message || '請填寫報修日';
  }

  if (code === 'REPAIR_REQUEST_SERIAL_NO_REQUIRED') {
    return data?.message || '請填寫產品序號';
  }

  if (code === 'REPAIR_REQUEST_SERIAL_NO_DUPLICATE') {
    return data?.message || '同一張報修單的產品序號不可重複';
  }

  if (code === 'SN_FORMAT_INVALID') {
    return data?.message || '序號格式不符，請修正該序號';
  }

  if (code === 'SN_PRODUCT_MAPPING_NOT_FOUND') {
    return data?.message || '此序號沒有產品名稱對照，請先建立對照';
  }

  if (code === 'SN_PRODUCT_MAPPING_NOT_AVAILABLE') {
    return data?.message || '此序號的對照仍是待指定，請先指定客戶並啟用後再成立';
  }

  if (code === 'REPAIR_REQUEST_SERIAL_IN_REPAIR') {
    return formatSerialInRepairMessage(data);
  }

  if (code === 'REPAIR_REQUEST_UPDATE_NOT_ALLOWED') {
    return data?.message || '僅草稿可編輯';
  }

  if (code === 'REPAIR_REQUEST_CANCEL_NOT_ALLOWED') {
    return data?.message || '僅草稿可刪除';
  }

  if (code === 'REPAIR_REQUEST_ESTABLISH_NOT_ALLOWED') {
    return data?.message || '僅草稿可成立';
  }

  if (code === 'REPAIR_REQUEST_CORRECTION_REASON_REQUIRED') {
    return data?.message || '請填寫更正原因';
  }

  if (code === 'REPAIR_REQUEST_CORRECTION_EMPTY') {
    return data?.message || '沒有需要更正的資料';
  }

  if (code === 'REPAIR_REQUEST_CORRECTION_NOT_ALLOWED') {
    return data?.message || '僅處理中的報修單可更正';
  }

  if (code === 'REPAIR_REQUEST_LINE_CORRECTION_NOT_ALLOWED') {
    return data?.message || '此品項已修復、拒修、已結案或已鎖定，不可更正';
  }

  if (code === 'REPAIR_REQUEST_LINE_REMOVE_NOT_ALLOWED') {
    return data?.message || '此品項已修復、拒修、已結案或已鎖定，不可移除';
  }

  if (code === 'REPAIR_REQUEST_LAST_LINE_NOT_REMOVABLE') {
    return data?.message || '報修單至少要保留一筆品項';
  }

  if (code === 'REPAIR_REQUEST_REPORT_DRAFT_EXISTS') {
    return data?.message || '此品項有維修報告草稿，請先到維修報告取消草稿';
  }

  if (code === 'REPAIR_REQUEST_LINE_NOT_FOUND') {
    return data?.message || '找不到這筆報修品項，請重新載入';
  }

  if (code === 'REPAIR_REQUEST_PROBLEM_DESCRIPTION_REQUIRED') {
    return data?.message || '請填寫問題描述';
  }

  if (code === 'REPAIR_REQUEST_COMPLETION_NOT_PENDING') {
    return data?.message || '目前不需要確認完成，請重新載入';
  }

  if (code === 'REPAIR_REQUEST_COMPLETION_NOT_ALLOWED') {
    return data?.message || '仍有品項尚未有最終報告，無法完成';
  }

  if (code === 'MATERIAL_SN_RETEST_REQUIRED') {
    return data?.message || '此序號需要重測後才能繼續，已開啟序號檢測履歷';
  }

  return data?.message || fallback;
}

function formatSerialInRepairMessage(data) {
  const details = Array.isArray(data?.details) ? data.details : [];
  const lines = details.map((item) => {
    const serial = item?.serialNo ?? item?.serial_no;
    if (!serial) {
      return null;
    }
    const requestNo = item?.repairRequestNo ?? item?.repair_request_no;
    const extra = [requestNo, item?.status].filter(Boolean).join('／');
    return extra ? `${serial}（${extra}）` : String(serial);
  }).filter(Boolean);
  const base = data?.message || '同一序號尚有未完結維修品';
  if (lines.length === 0) {
    return base;
  }
  return `${base}：${lines.join('、')}`;
}

export function isRepairRequestVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}

export function isRepairRequestNoDuplicated(error) {
  return error?.response?.data?.code === 'REPAIR_REQUEST_NO_DUPLICATED';
}
